const React = require('react');
const Link = require('react-router-dom').Link;
const SharedModels = require('../../../shared/sharedModels');
const AjaxFunctions = require('./ajaxFunctions.js');
const ReduxStore = require('./redux/reduxStore.jsx');
const MessageSideBar = require('./components/messageSidebar.jsx').MessageSideBar;
const Utils = require('./utils');
import ReactLinkify from 'react-linkify';
import { Grid } from '@material-ui/core';
import socketIOClient from "socket.io-client";

export class Messages extends React.Component{
   constructor(props) {
      super(props);
      this.state ={
         newMessage: '',
         overviewData: [],
         messageList: [],
         correspondent: new SharedModels.User({}),
      };
   }

   async updateSummary(){
      let data = await AjaxFunctions.getPrivateMessageOverview();
      this.setState({overviewData: data.messages});
   }

   async setCorrespondent(idCorrespondent){
      let data = await AjaxFunctions.getPrivateMessages(idCorrespondent);
      this.setState({messageList: data.messages, correspondent: data.correspondent});
      let div = document.getElementById("conversationContainer");
      div.scrollTop = div.scrollHeight;
   }

   componentDidMount(){
      const socket = socketIOClient(window.globals.socketConnection, {transports: ["websocket"]});
      socket.on(`UpdateMessagesForUser${window.globals.idUser}`, async data => {
         AjaxFunctions.getPrivateMessages(this.state.correspondent.id).then((data) => {
         this.setState({messageList: data.messages});
         let div = document.getElementById("conversationContainer");
         div.scrollTop = div.scrollHeight;
         });
        });      
      AjaxFunctions.setPrivateMessagesAsRead().then(() => {
         ReduxStore.store.dispatch(ReduxStore.UserFunctions.setMessagesRead());
      });
      this.updateSummary();

      let correspondentFromUrl = Utils.getParameterByName('idCorrespondent', window.location.href);
      if(correspondentFromUrl){
         this.setCorrespondent(correspondentFromUrl);
      }

   }


   sendMessage(){
      if(this.state.newMessage.trim() === '')
         return;

      AjaxFunctions.sendPrivateMessage(this.state.correspondent.id, this.state.newMessage, '').then(() =>{
         $('#newMessageText').val('');
         this.setState({newMessage: ''});
         AjaxFunctions.getPrivateMessages(this.state.correspondent.id).then((data) => {
            this.setState({messageList: data.messages});
            let div = document.getElementById("conversationContainer");
            div.scrollTop = div.scrollHeight;
         })
      })
   }

   handleOnKeyUp(e){
      if (e.keyCode === 13) {
         // Trigger the button element with a click
         this.sendMessage();
      }
   }

   render(){
      let messages = <div>No Messages Yet</div>;

      if(this.state.messageList.length > 0) {
         messages = this.state.messageList
            .sort((a,b) => new Date(a.sendTime) - new Date(b.sendTime))
            .map((pm) => {
            return (
               <div className="message-container" key={pm.id}>
                  <div className={'message ' + (pm.idUserFrom === parseInt(window.globals.idUser) ? 'own' : '')}>
                     <div className={'message-date'}>
                        {new Date(pm.sendTime).toLocaleString()}
                     </div>
                     {pm.idUserFrom === 1 ? (
                        <ReactLinkify properties={{target: '__blank'}}>
                           {pm.message}
                        </ReactLinkify>
                     ) : (
                        <div>
                           <ReactLinkify>
                              {pm.message}
                           </ReactLinkify>
                        </div>
                     )}
                  </div>
               </div>
            )
         });
      }

      let submitButton = () => {
         if(this.state.correspondent.id) {
            return (
               <button className="btn secondary mb-2" onClick={() => this.sendMessage()}>Send</button>
            )
         }
         return(<span>No recipient selected</span>)
      };

      let recipientHeader = () => {
         if(this.state.correspondent.id){
            return(
               <Link to={'/users/profile?idUser=' + this.state.correspondent.id}>
                  <div>
                     {this.state.correspondent.firstName + ' ' + this.state.correspondent.lastName}
                  </div>
               </Link>
            )
         }
         return(<span>Use the left bar to choose a user to message</span>)
      };

      return(
         <Grid container spacing={2} className={'page-container'} >
            <Grid item lg={3}>
            <MessageSideBar
               setCorrespondent={(idCorrespondent) => this.setCorrespondent(idCorrespondent)}
               overviewData={this.state.overviewData}
            />
            </Grid>
            <Grid item lg={9}>
            <div className="d-block" id='messagesContainer'>
               <div className="conversation-container" id='conversationContainer'>
                  <div className="conversation">
                     {recipientHeader()}
                     <div className={'conversation-messages'}>
                        {messages}
                     </div>
                  </div>
               </div>
               <div className="message-control">
                  <div className="form-group">
                     <div className="row">
                        <div className="col">
                           <input
                              className="form-control"
                              type="text"
                              placeholder="Start your message here"
                              maxLength={800}
                              aria-label="Add Note"
                              id='newMessageText'
                              onChange={(e) => this.setState({newMessage: e.target.value})}
                              onKeyUp={(e) => this.handleOnKeyUp(e)}
                           />
                        </div>
                        <div className="col-auto">
                           {submitButton()}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            </Grid>
            </Grid>
      );
   }
};